export default __webpack_public_path__ + "static/media/es-variant.734fc263.svg";